import { render, staticRenderFns } from "./jump4.vue?vue&type=template&id=0c9d0c89&scoped=true"
import script from "./jump4.vue?vue&type=script&lang=js"
export * from "./jump4.vue?vue&type=script&lang=js"
import style0 from "./jump4.vue?vue&type=style&index=0&id=0c9d0c89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d0c89",
  null
  
)

export default component.exports